import React from 'react';

export default function DeafCultureGuide() {
  return <p>Teste página guia cultura surda</p>;
}
